export default __webpack_public_path__ + "static/media/macroon.8cbaa3b1.png";